import { mapPermissionsV2ScopeKeys } from 'Models/AuthorizeV2/checkAuthorizationV2'
import { Model } from 'dva'
import TagManager from 'react-gtm-module'
import { UsersService } from '../../Service'
import { resetReduxExceptUndoRedo, resetUndoRedo } from '../../Utils/resetReduxState'

const userAuth = {
  user: {},
}

const Auth: Model = {
  namespace: 'auth',
  state: userAuth,
  effects: {
    *homeApi(
      { loggedIn = () => {}, notLoggedIn = () => {}, setLoading = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        resetReduxExceptUndoRedo()
        const response = yield call(UsersService.usersHomeRetrieve)
        let user = yield select((state: any) => state.auth.user)
        if (user.email !== response.email) {
          resetUndoRedo()
        }
        yield put({ type: 'setUser', payload: response })
        loggedIn(response)
      } catch (err) {
        console.error(err)
        notLoggedIn(err)
      }
      setLoading(false)
    },
    *userSignOut({ onSuccess = () => {}, onFailure = () => {} }, { call, put }) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      sessionStorage.clear()
      onSuccess()
      // window.location.reload();
    },
  },
  reducers: {
    setUser(state, action) {
      // Update Google Tag Manager For Monitoring / Analytics
      const tagManagerArgs = {
        dataLayer: {
          userId: action.payload?.id,
          userEmail: action.payload?.email,
        },
      }
      if (process.env.NODE_ENV !== 'development') {
        TagManager.dataLayer(tagManagerArgs)
      }
      const permissions_v2 = mapPermissionsV2ScopeKeys(action?.payload?.permissions_v2) || {
        organisations: {},
        flows: {},
        independent: [],
      }
      return {
        ...state,
        user: { ...action.payload, permissions_v2 },
      }
    },
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      }
    },
    resetUserAuth(state, action) {
      return {
        ...state,
        user: {},
      }
    },
  },
}

export default Auth
